const STORAGE_KEY = 'dijo-notification-locally-read';

export const getLocallyReadNotificationIds = (): number[] => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);

    if (!value) {
      return [];
    }

    const parsed: unknown = JSON.parse(value);

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.filter((id): id is number => typeof id === 'number');
  } catch {
    return [];
  }
};

export const addLocallyReadNotificationId = (id: number): void => {
  const ids = new Set(getLocallyReadNotificationIds());
  ids.add(id);
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
};

export const toLocallyReadIdSet = (ids: number[]): ReadonlySet<number> =>
  new Set(ids);
